import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=5dd1b6f8&scoped=true&"
import script from "./Archive.vue?vue&type=script&lang=js&"
export * from "./Archive.vue?vue&type=script&lang=js&"
import style0 from "./Archive.vue?vue&type=style&index=0&id=5dd1b6f8&lang=scss&scoped=true&"
import style1 from "./Archive.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd1b6f8",
  null
  
)

export default component.exports